import { Text, View, StyleSheet, Font, Image } from '@react-pdf/renderer'
import React from 'react'
import LatoRegular from '../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
import RelectAndIntegrate1Image from "../../../Assets/Images/RelectAndIntegrate1Image.png";
import RelectAndIntegrateIcon from "../../../Assets/Images/RelectAndIntegrateIcon.png"

const LifeIntegration2 = () => {

    Font.register({
        family: 'Lato',
        fonts: [
            { src: LatoRegular, fontWeight: 400 },
            { src: LatoBold, fontWeight: 700 }
        ]
    });


    const styles = StyleSheet.create({
        footer: {
            position: "absolute",
            bottom: "0px",
            borderTop: "1px solid #426B88",
            display: "flex",
            flexDirection: "row",
            width: "571px",
            gap: "30px"
        },
        pagewapper: {
            position: "relative",
            height: "100%"
        },
        footertitle: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "10px",
            lineHeight: "18px",
            color: "#76A3BE",
            textTransform: "uppercase",
            marginTop: "10px"
        },
        description: {
            color: "#76A3BE",
            fontFamily: "Lato",
            fontWeight: 400,
            fontSize: "8px",
            lineHeight: "18px",
            width: "496px"

        },
        pagenumber: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "10px",
            lineHeight: "18px",
            color: "#76A3BE",
            marginTop: "10px",
        },
        image: {
            width: "574px",
            height: "300px",

        },
        content: {
            width: "570px",
            height: "710px",
            display: "flex",
            flexDirection: "column",
            marginTop: "10px"
        },
        imageContainer: {
            width: "574px",
            height: "300px",
        },
        contentDescription: {
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            fontFamily: "Lato",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "18px",
            color: "#245775"
        },
        icon: {
            width: "68px",
            height: "68px"
        },
        text: {
            fontFamily: "Lato",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "30px",
            color: "#426B88",
            marginBottom: "2px"
        },
        header: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: "#5795B2",
            borderBottom: "1px solid #5795B2"
        },
        title: {
            width: "183px",
            fontSize: "14px",
            fontFamily: "Lato",
            lineHeight: "18px",
            color: "#5795B2",
            fontWeight: 400,

        },
        titlebold: {
            fontWeight: 700
        },
        details: {
            fontSize: "10px",
            fontFamily: "Lato",
            lineHeight: "16px",
            color: "#5795B2",
            fontWeight: 400,
            width: "73px",
            textAlign: "right"

        },
        textbold: {
            fontWeight: 700
        },
        bold: {
            fontWeight: 700
        }
    });
    return (

        <View style={styles.pagewapper}>
            <View style={styles.header}>
                <View style={styles.title}>
                    <Text style={styles.titlebold}>Quadrant Flow</Text>
                    <Text>Life & Leadership Assessment</Text>
                </View>
                <View style={styles.details}>
                    <Text style={styles.textbold}>Rob Murray</Text>
                    <Text>Atlas Real Estate</Text>
                    <Text>Oct 18, 2024</Text>
                </View>
            </View>
            <View style={styles.content}>
                <Text style={styles.text}>FINAL THOUGHTS</Text>
                <View style={styles.contentDescription}>
                    <View>
                        <Text>Thank you for taking the time to review your assessment results. As you move forward, we encourage you to reflect on the insights you've gained and put them into action. To turn this information into a true opportunity for transformation, we recommend connecting with your coach or consultant to guide you through the next steps. Your continued growth as a leader will shape not only your life but also the lives of those you influence.</Text>
                    </View>
                    <View>
                        <Text style={styles.bold}>Acknowledgments</Text>
                        <Text>This report and the accompanying tools are designed to support you on your leadership journey. We hope they provide clarity and direction as you work to align your life and leadership with your core values and goals.</Text>
                    </View>
                    <View>
                    <Text style={styles.bold}>Copyright</Text>
                    <Text>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved. Unauthorized duplication or distribution of this material is prohibited without explicit permission.</Text>
                    </View>
                </View>
            </View>
            <View style={styles.footer}>
                <View>
                    <Text style={styles.footertitle}>SELF Report</Text>
                    <Text style={styles.description}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
                </View>
                <View style={styles.pagenumber}>
                    <Text>PAGE</Text>
                </View>

            </View>

        </View>

    )
}

export default LifeIntegration2